import { GzEasmVulnerableServicesWebComponent } from './component/GzEasmVulnerableServicesWebComponent';

export { GzEasmVulnerableServicesWebComponent };
